export default __webpack_public_path__ + "static/media/IBimageMobilityAnkle.ab5a2969.png";